module.exports = __webpack_public_path__ + "media/teal-red-buildings-illustration.3355d123.png";